import { normalizarData, normalizarValor } from '../../utils/index';

/**
 * Retorna TRUE se o array de dados (Sheet->JSON) se parecer com
 * um arquivo de Comprovante de Pagamentos da Stone.
 */
export const detectar = (dadosArray) => {
    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const cleanRow = linha.map(c => String(c || '').trim().toLowerCase());
        
        // Stone identifica pelo cabeçalho "StoneCode" ou especificidade do layout
        if (
            cleanRow.includes('valor') && 
            cleanRow.includes('data de pagamento') && 
            (cleanRow.includes('stonecode') || cleanRow.includes('status do pagamento'))
        ) {
            return true;
        }
    }
    return false;
};

/**
 * Processa a planilha bruta e retorna array mapeado.
 */
export const processar = (dadosArray) => {
    let idxCabecalho = -1;
    let idxValor = -1;
    let idxData = -1;
    let idxStatus = -1;
    let idxProduto = -1;

    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const cleanRow = linha.map(c => String(c || '').trim().toLowerCase());
        
        const possibleValorIdx = cleanRow.indexOf('valor');
        const possibleDataIdx = cleanRow.indexOf('data de pagamento');
        const possibleStatusIdx = cleanRow.indexOf('status do pagamento');
        const possibleProdutoIdx = cleanRow.findIndex(c => c.includes('produto') || c.includes('tipo'));

        if (possibleValorIdx !== -1 && possibleDataIdx !== -1) {
            idxCabecalho = i;
            idxValor = possibleValorIdx;
            idxData = possibleDataIdx;
            idxStatus = possibleStatusIdx;
            idxProduto = possibleProdutoIdx;
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho Stone não encontrado.');
    }

    const repasses = [];
    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        // Validar status se existir (Stone usa "Pago" para liquidados)
        if (idxStatus !== -1) {
            const status = String(linha[idxStatus] || '').trim().toLowerCase();
            if (status !== 'pago') continue;
        }

        const dataStr = String(linha[idxData] || '').trim();
        if (!dataStr) continue;

        const data = normalizarData(dataStr);

        let valor = null;
        const valorRaw = linha[idxValor];
        
        if (typeof valorRaw === 'number') {
            // Se o valor for um número inteiro, tratamos como centavos (Padrão Stone/XLSX)
            // ex: 125052 vira 1250.52
            if (Number.isInteger(valorRaw)) {
                valor = valorRaw / 100;
            } else {
                valor = valorRaw;
            }
        } else {
            valor = normalizarValor(valorRaw);
        }

        let tipoStr = 'Desconhecido';
        if (idxProduto !== -1 && linha[idxProduto]) {
            tipoStr = String(linha[idxProduto]).trim();
        }

        if (data && valor !== null && valor > 0) {
            repasses.push({
                linha: i + 1,
                data: data,
                valor: valor,
                dataOriginal: dataStr,
                tipo: tipoStr
            });
        }
    }

    return repasses;
};
